import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const names = ['Joaquín Pérez', 'Matías González', 'Santiago Rodríguez', 'Lucas Fernández', 'Franco López', 'Agustín Martínez', 'Nicolás Silva', 'Tomás Romero'];
const cities = ['Mar del Plata', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const interval = setInterval(showPopup, 10000);
    // Show first popup after 3 seconds
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-126">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-127">
          <div className="bg-white rounded-lg shadow-2xl p-4 border-l-4 border-emerald-600" data-id="element-128">
            <div className="flex items-start gap-3" data-id="element-129">
              <div className="w-10 h-10 rounded-full bg-emerald-600 flex items-center justify-center flex-shrink-0" data-id="element-130">
                <ShoppingBag className="w-5 h-5 text-white" data-id="element-131" />
              </div>

              <div className="flex-1" data-id="element-132">
                <p className="font-semibold text-gray-900 text-sm" data-id="element-133">
                  {currentName} de {currentCity}
                </p>
                <p className="text-gray-600 text-sm" data-id="element-134">
                  acaba de comprar este libro digital
                </p>
              </div>

              <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 flex-shrink-0" data-id="element-135">
                <X className="w-4 h-4" data-id="element-136" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}